<template>
  <div class="work-content-page">
    <van-form :show-error="false" :submit-on-enter="false" :show-error-message="false" @submit="onSubmit" @failed="onFailed">
      <van-field
        v-model="content"
        type="textarea"
        name="content"
        show-word-limit
        maxlength="1000"
        label=""
        placeholder="请填写您担任职位的工作内容"
        :rules="[{ required: true, message: '' }]"
      />
      <div class="submit-content">
        <van-button class="submit-btn" :class="{'disabled':content.length <= 0}" type="info" native-type="submit"><span>确定</span></van-button>
      </div>
    </van-form>

  </div>
</template>

<script>
import { Toast  } from 'vant'

import cookies from "@/libs/util.cookies";
import util from "../../../libs/util";
export default {
  name: 'ResumeWorkContent',
  data() {
    return {
      content:'',
      workDetail:{},
      user_id:cookies.get('uid') || ''
    };
  },
  created() {
    const shareParam = {
      title: "卫宁健康期待您的加入",
      desc: "正在热招",
      link: process.env.VUE_APP_BASEURL +'#/',
      imgUrl: process.env.VUE_APP_SHARE_IMG_URL
    }
    util.initWXSdk(shareParam)
  },
  mounted() {
    this.init()
  },
  methods: {
    init(){
      let data = sessionStorage.getItem('workDetail')
      try {
        this.workDetail = JSON.parse(data) || {}
      } catch (error) {
        this.workDetail = {
          id:this.$route.params.workId,
          user_id:this.user_id,
        }
      }
      this.content = this.workDetail.job_content || ''
    },
    onSubmit(){
      this.workDetail.job_content = this.content
      sessionStorage.setItem('workDetail' ,JSON.stringify(this.workDetail))
      this.$router.push( { name: 'ResumeWork', params: {workId:this.workDetail.id} } )
    },
    onFailed(){
      Toast('请填写工作内容')
    }
  },

}
</script>

<style scoped>
  .work-content-page{
    text-align:left;
    font-size:16px;
    margin-top:10px;
  }

  .submit-content{
    display:flex;
    justify-content: space-between;
    position:fixed;
    bottom:0px;
    left:0;
    width:calc(100vw - 40px);
    padding:10px 20px 20px 20px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
    font-weight: bold;
  }

  .submit-btn{
    flex:1;
    height:44px;
    background: linear-gradient(90deg, #3871FF 0%, #2E5DD2 100%);
    border-radius: 22px;
    font-size:16px;
    color:#fff;
  }

  .submit-btn.disabled span{
    opacity:0.5;
  }

  ::v-deep .van-cell{
    padding:10px 20px 20px 20px;
  }

  ::v-deep .van-cell::after{
    display:none;
  }

  ::v-deep .van-cell textarea{
    height:calc(100vh - 180px);
    font-size:16px;
  }

  ::v-deep .van-field__word-limit{
    font-size:12px;
    color:#999999;
  }

  ::v-deep .van-field__word-num{
    color:#333;
  }

</style>
